import { Button } from '@dasa-health/components-react'
import React, { ReactNode } from 'react'

interface SignUpHelpTextModalProps {
    onClick: () => void
    children: ReactNode
}

export const SignUpHelpTextModal = ({ onClick, children }: SignUpHelpTextModalProps) => (
    <Button
        onClick={onClick}
        sx={{
            fontSize: '.875rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            letterSpacing: '0',
            textAlign: 'center',
            justifyContent: 'center',
            width: 'auto',
            marginLeft: '-1.25rem',
            paddingRight: '0',
        }}
        type="button"
        variant="tertiary"
    >
        {children}
    </Button>
)
